angular.
module("dx.webapp.masterTools.studentMerge").
component("dxExamAnswers", {
	templateUrl: "tmpl/mastertools/studentmerge/exam-answers-component.html",
	controller: "DxExamAnswersController",
	controllerAs: "vm",
	bindings: {
		questions: "<",
		answers: "<",
	},
});
